import { constructEnum } from '@/lib/enum';

export default constructEnum('ReviewSentimentType', {
  STRONG_NEGATIVE: -2,
  NEGATIVE: -1,
  NEUTRAL: 0,
  POSITIVE: 1,
  STRONG_POSITIVE: 2
});
